import { AccountStatus, CustomerAccount } from './types'

export const isAccountActive = (customerAccount: CustomerAccount): boolean =>
  customerAccount.accountStatus === AccountStatus.ACTIVE

export const isCustomerAccount =
  (accountCode: string) => (customerAccount: CustomerAccount) =>
    customerAccount.accountCode === accountCode
